import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const LayersIcon = createIcon({
  displayName: 'LayersIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill='currentColor'
      d='M12 2 1 8l11 6 11-6-11-6Zm0 13.5L3.6 10.9 1 12l11 6 11-6-2.6-1.1L12 15.5Z'
    />
  ),
});
